module.exports = __webpack_public_path__ + "static/media/mastercard.0ef7a527.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/mastercard.svg
// module id = 855
// module chunks = 7